<template>
  <lazy-component tag="div" class="iframe-lazy-wrapper" ref="iframeLazy">
    <iframe v-bind="item.content.attr" ref="iframe"></iframe>
  </lazy-component>
</template>

<script>
import iframeResponsiveWrapper from 'components/mixins/iframeResponsiveWrapper'

export default {
  name: 'body-iframe',
  props: ['item'],
  mixins: [iframeResponsiveWrapper],
  mounted() {
    this.$watch('$refs.iframeLazy.state.loaded', () => {
      if (this.$refs.iframeLazy.state.loaded) {
        this.iframeResponsiveWrapper([this.$refs.iframe])
      }
    })
  },
}
</script>



// WEBPACK FOOTER //
// Iframe.vue?16cd1612